import React from "react";

import { TagResponse } from "@every.org/common/src/codecs/entities";
import { isValidUsername } from "@every.org/common/src/codecs/username";
import {
  atLeastAsPrivilegedAs,
  AdminLevel,
} from "@every.org/common/src/entity/types";

import { LoadingPage } from "src/components/LoadingPage";
import { RedirectToUserOrNotFound } from "src/components/Nonprofit/RedirectToUserOrNotFound";
import { FeedItems } from "src/components/Tags/TagNonprofitsTab";
import { useLoggedInUserOrUndefined } from "src/context/AuthContext/hooks";
import { useTag } from "src/context/TagContext/hooks";
import { TagFetchStatus } from "src/context/TagContext/types";
import { NotFoundPage } from "src/pages/NotFound";
import TagFeedPage from "src/pages/Tags/TagFeedPage";
import { ClientTrackingRoute, trackPageChange } from "src/utility/analytics";

/**
 * The tag page uses the cause page as a template to recommend nonprofits
 * related to the tag
 */
export const TagPage: React.FCC<{
  tagName: TagResponse["tagName"];
  initialFeedItems?: FeedItems;
}> = ({ tagName, initialFeedItems }) => {
  const loggedInUser = useLoggedInUserOrUndefined();
  const onlyActive = !(
    loggedInUser &&
    atLeastAsPrivilegedAs({
      level: loggedInUser?.adminLevelForDisplay || AdminLevel.RESTRICTED,
      compareAgainst: AdminLevel.MODERATOR,
    })
  );

  const tag = useTag({ tagName }, onlyActive);

  if (tag === TagFetchStatus.FETCHING_TAG) {
    return <LoadingPage />;
  }
  if (tag === TagFetchStatus.TAG_NOT_FOUND) {
    if (!isValidUsername(tagName)) {
      return <NotFoundPage />;
    }
    return <RedirectToUserOrNotFound username={tagName} />;
  }
  trackPageChange(ClientTrackingRoute.CAUSE, tagName);

  return <TagFeedPage tag={tag} initialFeedItems={initialFeedItems} />;
};

export default TagPage;
